import { createAction, createReducer } from 'typesafe-actions';
import { ThunkAction } from 'redux-thunk';

import { getImageUrl, convertImageUrl, imageRendering } from '../utils/network';

export type ImageState = {
  header_icon: string;
  kisa_bar: string;
  error_server: string;
  error_client: string;
};

// 각 이미지들의 저해상도 즈소로 State 초기화
const initialState: ImageState = {
  header_icon: getImageUrl('header_icon.png', 'low'),
  kisa_bar: getImageUrl('kisa_bar.png', 'low'),
  error_server: getImageUrl('error_server.png', 'low'),
  error_client: getImageUrl('error_client.png', 'low'),
};

/* Types */
// 고해상도 Header Icon Image 로드하여 저해상도를 대체
export const HEADER_ICON = 'image/HEADER_ICON';
// 고해상도 MyKeepin App Bar Image 로드하여 저해상도를 대체
export const KISA_BAR = 'image/KISA_BAR';
// 고해상도 Server Error Image 로드하여 저해상도를 대체
export const ERROR_SERVER = 'image/ERROR_SERVER';
// 고해상도 Client Error Image 로드하여 저해상도를 대체
export const ERROR_CLIENT = 'image/ERROR_CLIENT';

/* Actions */
type ImageAction = { type: string; payload: string };

// 고해상도 이미지를 로드하여 저해상도 이미지를 대체하는 비동기 액션(Thunk)
type ImageThunkAction = ThunkAction<void, ImageState, null, ImageAction>;
export function imageThunk(type: string, url: string): ImageThunkAction {
  // 액션 객체 생성
  const action = createAction(type)<string>();
  return async dispatch => {
    try {
      // 저해상도 이미지 주소를 고해상도 이미지 주소 생성
      const converted = convertImageUrl(url, 'high');
      const image = await imageRendering(converted);
      dispatch(action(image));
    } catch (err) {
      dispatch(action(''));
    }
  };
}

/**
 * @description 저해상도 이미지는 URL 형식이고, 고해상도 이미지는 base64 형식. 이를 가지고 고해상도인지 구분
 * @param {string} str 이미지 주소
 * @returns {string | boolean} 고새상도면 그대로 주소를 반환, 고해상도 주소가 아니면 False 반환
 */
export const check = (str: string) =>
  str.startsWith('data:;base64,') ? str : false;

const image = createReducer<ImageState, ImageAction>(initialState, {
  // 고해상도 Header Icon Image 로드하여 저해상도를 대체
  [HEADER_ICON]: (state, action) => {
    const header_icon = check(action.payload) || state.header_icon;
    return { ...state, header_icon };
  },
  // 고해상도 MyKeepin App Bar Image 로드하여 저해상도를 대체
  [KISA_BAR]: (state, action) => {
    const kisa_bar = check(action.payload) || state.kisa_bar;
    return { ...state, kisa_bar };
  },
  // 고해상도 Server Error Image 로드하여 저해상도를 대체
  [ERROR_SERVER]: (state, action) => {
    const error_server = check(action.payload) || state.error_server;
    return { ...state, error_server };
  },
  // 고해상도 Client Error Image 로드하여 저해상도를 대체
  [ERROR_CLIENT]: (state, action) => {
    const error_client = check(action.payload) || state.error_client;
    return { ...state, error_client };
  },
});

export default image;
